import React from "react";
import css from "./TermDropdown.css";
import Select from "../common/StyledSelect";
import PropTypes from "prop-types";
import moment from "moment";
import { organizeHierarchicalTerms } from "../utils/scheduleBlockReport";

const TermDropdown = props => {
  const termHierarchy = organizeHierarchicalTerms(props.terms)
  const termOptions = (terms) => {
    if (!terms) return;
    return terms.filter(term => term.termName !== 'Ongoing')
      .map(term => ({
          value: term.termId,
          label: term.termName
        })
      )
  };

  const setSelectedTermDates = selectedTerm => {
    const termId = selectedTerm || {}
    const foundTerm = props.terms.find(t => t.termId === termId.value);
    if (foundTerm) {
        props.setStartDate(moment(foundTerm.startDisplay, 'YYYY-MM-DD HH.mm'));
        props.setEndDate(moment(foundTerm.endDisplay, 'YYYY-MM-DD HH.mm'));
        props.setSelectedTerm(selectedTerm);
    } else {
        props.setSelectedTerm(null);
        props.setStartDate(null);
        props.setEndDate(null);
    }
  };

  return <div className={css['select-container']}>
            <label htmlFor={"terms-select"} className={css['field-label']}>Term:</label>
            <div className={css['term-select']}>
              <Select
                id="terms-select"
                placeholder="Use dates below"
                options={termOptions(termHierarchy)}
                value={props.selectedTerm}
                onChange={selectedTerm => setSelectedTermDates(selectedTerm)}
                maxMenuHeight={730}
                isSearchable={true}
                isClearable={true}
                singleValueNoWhiteSpace={true}
                aria-label="Select a term to prepopulate start and end dates."
              />
              <span className={css["help-text"]}>
                  Select a term to prepopulate start and end dates.
              </span>
            </div>
         </div>
};

TermDropdown.propTypes = {
  terms: PropTypes.array.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setSelectedTerm: PropTypes.func.isRequired,
  selectedTerm: PropTypes.object
};

export default TermDropdown;
